import React, { ReactNode } from "react";

// Interface pour les options
interface OptionType {
  id: string;
  label: string;
  value: string;
}

// Interface pour les props du SelectorMenu
interface SelectorMenuProps {
  options: OptionType[];
  value: string;
  onChange: (value: string) => void;
  label?: string | ReactNode;
  className?: string;
}

// Composant SelectorMenu avec typage et label inline
const SelectorMenu: React.FC<SelectorMenuProps> = ({
  options,
  value,
  onChange,
  label,
  className = "",
}) => {
  return (
    <div className={`flex flex-col w-full ${className}`}>
      {label && (
        <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider mb-1.5">
          {label}
        </label>
      )}
      <div className="relative">
        <select
          className="w-full appearance-none pl-3 pr-10 py-2.5 bg-white border border-gray-200 hover:border-emerald-400 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100 rounded-lg text-sm text-gray-800 shadow-sm transition-all duration-200 outline-none cursor-pointer"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          {options.map((option) => (
            <option key={option.id} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-500">
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default SelectorMenu;
